import { render, staticRenderFns } from "./CardProfile.vue?vue&type=template&id=2fd932d8&"
import script from "./CardProfile.vue?vue&type=script&lang=js&"
export * from "./CardProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports